import React from "react";

// TODO: get all icons from Figma
// https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/%E2%9D%96-Web-(Logged-In)

export const icons = {
  chat_bubble: {
    viewBox: "0 0 20 19",
    path: (
      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M2.90001 19C2.78401 18.997 2.67901 18.952 2.60001 18.88C2.49201 18.785 2.42401 18.645 2.42401 18.49C2.42401 18.422 2.43701 18.356 2.46101 18.296L4.11001 14.08C1.75101 12.894 0.132007 10.545 0.00100725 7.807C7.24709e-06 3.5 4.49001 0 10 0C15.51 0 20 3.5 20 7.79C20 12.08 15.51 15.58 10 15.58C9.37901 15.58 8.76901 15.536 8.17101 15.452L3.16001 18.92C3.08701 18.97 2.99701 19 2.90001 19ZM10 1C5.00001 1 1.00001 4 1.00001 7.79C1.00001 10.03 2.49001 12.13 5.00001 13.41C5.16001 13.498 5.26701 13.666 5.26701 13.859C5.26701 13.928 5.25301 13.994 5.22801 14.054L3.91901 17.211L7.91901 14.521C7.99201 14.47 8.08301 14.44 8.18001 14.44C8.23001 14.44 8.27701 14.448 8.32201 14.462C8.83301 14.537 9.42601 14.581 10.029 14.581C10.032 14.581 10.036 14.581 10.039 14.581C15.038 14.581 19.038 11.581 19.038 7.791C19.038 4.001 14.998 1.001 9.99801 1.001L10 1Z"
        }
        fill={"currentColor"}
      />
    )
  },
  account: {
    path: (
      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M2 11.931C2 6.44612 6.44612 2 11.931 2C17.4159 2 21.8621 6.44612 21.8621 11.931C21.8621 17.4159 17.4159 21.8621 11.931 21.8621C6.44612 21.8621 2 17.4159 2 11.931ZM11.931 11.4345C10.0114 11.4345 8.45517 9.87829 8.45517 7.95862C8.45517 6.03895 10.0114 4.48276 11.931 4.48276C13.8507 4.48276 15.4069 6.03895 15.4069 7.95862C15.4069 9.87829 13.8507 11.4345 11.931 11.4345ZM11.931 5.47586C10.5596 5.47586 9.44827 6.58714 9.44827 7.95862C9.44827 9.3301 10.5596 10.4414 11.931 10.4414C13.3025 10.4414 14.4138 9.3301 14.4138 7.95862C14.4138 6.58714 13.3025 5.47586 11.931 5.47586ZM11.931 2.9931C16.8618 3.00105 20.856 6.99928 20.856 11.931C20.856 13.7822 20.293 15.5012 19.3296 16.9283C17.7218 14.4992 15.0087 12.944 11.931 12.944C8.8534 12.944 6.14025 14.4992 4.53241 16.8658C3.5691 15.5022 3.00601 13.7822 3.00601 11.931C3.00601 6.99928 7.00127 3.00105 11.931 2.9931ZM5.168 17.7526C6.80265 19.6554 9.22582 20.863 11.931 20.869C14.6402 20.866 17.0664 19.6584 18.6941 17.7069C17.2938 15.4466 14.7912 13.9411 11.936 13.9411C9.08083 13.9411 6.57821 15.4466 5.168 17.7526Z"
        }
        fill={"currentColor"}
      />
    )
  },
  add: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z"
        }
      />
    )
  },
  "arrow-back": {
    path: (
      <path
        fill={"currentColor"}
        d={"M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"}
      />
    )
  },
  "arrow-down": {
    path: (
      <path
        fill={"currentColor"}
        d={"M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"}
      />
    )
  },
  "arrow-forward": {
    path: (
      <path
        fill={"currentColor"}
        d={"M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"}
      />
    )
  },
  "arrow-left": {
    path: (
      <path
        d={"M15 6L9 11.9841L15 18"}
        fill={"none"}
        stroke={"currentColor"}
        strokeWidth={"1.4"}
        strokeLinecap={"round"}
      />
    )
  },
  "arrow-right": {
    path: (
      <g fill={"currentColor"}>
        <path
          d={
            "M13.584,12a2.643,2.643,0,0,1-.775,1.875L3.268,23.416a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L.768,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,13.584,12Z"
          }
        />
        <path
          d={
            "M23.75,12a2.643,2.643,0,0,1-.775,1.875l-9.541,9.541a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L10.934,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,23.75,12Z"
          }
        />
      </g>
    )
  },
  "arrow-up": {
    path: (
      <path
        fill={"currentColor"}
        d={"M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"}
      />
    )
  },
  "arrow-up-down": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M11.891 9.992a1 1 0 1 1 1.416 1.415l-4.3 4.3a1 1 0 0 1-1.414 0l-4.3-4.3A1 1 0 0 1 4.71 9.992l3.59 3.591 3.591-3.591zm0-3.984L8.3 2.417 4.709 6.008a1 1 0 0 1-1.416-1.415l4.3-4.3a1 1 0 0 1 1.414 0l4.3 4.3a1 1 0 1 1-1.416 1.415z"
        }
      />
    ),
    viewBox: "0 0 16 16"
  },
  "at-sign": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M12,.5A11.634,11.634,0,0,0,.262,12,11.634,11.634,0,0,0,12,23.5a11.836,11.836,0,0,0,6.624-2,1.25,1.25,0,1,0-1.393-2.076A9.34,9.34,0,0,1,12,21a9.132,9.132,0,0,1-9.238-9A9.132,9.132,0,0,1,12,3a9.132,9.132,0,0,1,9.238,9v.891a1.943,1.943,0,0,1-3.884,0V12A5.355,5.355,0,1,0,12,17.261a5.376,5.376,0,0,0,3.861-1.634,4.438,4.438,0,0,0,7.877-2.736V12A11.634,11.634,0,0,0,12,.5Zm0,14.261A2.763,2.763,0,1,1,14.854,12,2.812,2.812,0,0,1,12,14.761Z"
        }
      />
    )
  },
  attachment: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M21.843,3.455a6.961,6.961,0,0,0-9.846,0L1.619,13.832a5.128,5.128,0,0,0,7.252,7.252L17.3,12.653A3.293,3.293,0,1,0,12.646,8L7.457,13.184A1,1,0,1,0,8.871,14.6L14.06,9.409a1.294,1.294,0,0,1,1.829,1.83L7.457,19.67a3.128,3.128,0,0,1-4.424-4.424L13.411,4.869a4.962,4.962,0,1,1,7.018,7.018L12.646,19.67a1,1,0,1,0,1.414,1.414L21.843,13.3a6.96,6.96,0,0,0,0-9.846Z"
        }
      />
    )
  },
  bell: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
        }
      />
    )
  },
  calendar: {
    viewBox: "0 0 14 14",
    path: (
      <path
        fill={"currentColor"}
        d={
          "M10.8889,5.5 L3.11111,5.5 L3.11111,7.05556 L10.8889,7.05556 L10.8889,5.5 Z M12.4444,1.05556 L11.6667,1.05556 L11.6667,0 L10.1111,0 L10.1111,1.05556 L3.88889,1.05556 L3.88889,0 L2.33333,0 L2.33333,1.05556 L1.55556,1.05556 C0.692222,1.05556 0.00777777,1.75556 0.00777777,2.61111 L0,12.5 C0,13.3556 0.692222,14 1.55556,14 L12.4444,14 C13.3,14 14,13.3556 14,12.5 L14,2.61111 C14,1.75556 13.3,1.05556 12.4444,1.05556 Z M12.4444,12.5 L1.55556,12.5 L1.55556,3.94444 L12.4444,3.94444 L12.4444,12.5 Z M8.55556,8.61111 L3.11111,8.61111 L3.11111,10.1667 L8.55556,10.1667 L8.55556,8.61111 Z"
        }
      />
    )
  },
  cart: {
    path: (
      <path
        d={
          "M6 6L5.7 3H2.5C2.224 3 2 3.224 2 3.5C2 3.776 2.224 4 2.5 4H4.79L6 16H20.17L22 6H6ZM19.33 15H6.89L6.1 7H20.83L19.33 15ZM18 17C16.895 17 16 17.895 16 19C16 20.105 16.895 21 18 21C19.105 21 20 20.105 20 19C20 17.895 19.105 17 18 17ZM18 20C17.448 20 17 19.552 17 19C17 18.448 17.448 18 18 18C18.552 18 19 18.448 19 19C19 19.552 18.552 20 18 20ZM8 17C6.895 17 6 17.895 6 19C6 20.105 6.895 21 8 21C9.105 21 10 20.105 10 19C10 17.895 9.105 17 8 17ZM8 20C7.448 20 7 19.552 7 19C7 18.448 7.448 18 8 18C8.552 18 9 18.448 9 19C9 19.552 8.552 20 8 20Z"
        }
        fill={"currentColor"}
      />
    )
  },
  chat: {
    viewBox: "0 0 14 14",
    path: (
      <path
        fill={"currentColor"}
        d={
          "M0.913134,0.920639 C1.49851,0.331726 2.29348,0 3.12342,0 L10.8766,0 C11.7065,0 12.5015,0.331725 13.0869,0.920639 C13.6721,1.50939 14,2.30689 14,3.13746 L14,8.12943 C13.9962,8.51443 13.9059,8.97125 13.7629,9.32852 C13.6128,9.683 13.3552,10.0709 13.0869,10.3462 C12.813,10.6163 12.4265,10.8761 12.0734,11.0274 C11.7172,11.1716 11.2607,11.263 10.8766,11.2669 L10.1234,11.2669 L10.1234,12.5676 L10.1209,12.5676 C10.1204,12.793 10.0633,13.0791 9.97807,13.262 C9.8627,13.466 9.61158,13.7198 9.40818,13.8382 L9.40824,13.8383 C9.4077,13.8386 9.40716,13.8388 9.40661,13.8391 C9.40621,13.8393 9.4058,13.8396 9.40539,13.8398 L9.40535,13.8397 C9.22958,13.9254 8.94505,13.9951 8.75059,14 L8.74789,14 C8.35724,13.9963 7.98473,13.8383 7.71035,13.5617 L5.39553,11.2669 L3.12342,11.2669 C2.29348,11.2669 1.49851,10.9352 0.913134,10.3462 C0.644826,10.0709 0.387187,9.683 0.23711,9.32852 C0.0941235,8.97125 0.00379528,8.51443 0,8.12943 L0,3.13746 C0,2.30689 0.327915,1.50939 0.913134,0.920639 Z M3.12342,1.59494 C2.71959,1.59494 2.33133,1.75628 2.04431,2.04503 C1.75713,2.33395 1.59494,2.72681 1.59494,3.13746 L1.59494,8.12943 C1.59114,8.35901 1.62114,8.51076 1.71193,8.72129 C1.79563,8.9346 1.88065,9.06264 2.04431,9.22185 C2.33133,9.5106 2.71959,9.67195 3.12342,9.67195 L5.72383,9.67195 C5.93413,9.67195 6.13592,9.75502 6.28527,9.90308 L8.52848,12.1269 L8.52848,10.4694 C8.52848,10.029 8.88552,9.67195 9.32595,9.67195 L10.8766,9.67195 C11.1034,9.67583 11.2517,9.64614 11.4599,9.55518 C11.6712,9.47132 11.7976,9.38635 11.9557,9.22185 C12.1193,9.06264 12.2044,8.9346 12.2881,8.72129 C12.3789,8.51076 12.4089,8.35901 12.4051,8.12943 L12.4051,3.13746 C12.4051,2.72681 12.2429,2.33394 11.9557,2.04503 C11.6687,1.75628 11.2804,1.59494 10.8766,1.59494 L3.12342,1.59494 Z"
        }
      />
    )
  },
  check: {
    viewBox: "0 0 14 11",
    path: (
      <path
        d={
          "M4.78199 8.53941L1.66453 5.35829L0.602951 6.43392L4.78199 10.6983L13.7531 1.54399L12.699 0.468353L4.78199 8.53941Z"
        }
        fill={"currentColor"}
      />
    )
  },
  "checked-square": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M0.435974 2.18404C0 3.03969 0 4.15979 0 6.4V17.6C0 19.8402 0 20.9603 0.435974 21.816C0.819467 22.5686 1.43139 23.1805 2.18404 23.564C3.03969 24 4.15979 24 6.4 24H17.6C19.8402 24 20.9603 24 21.816 23.564C22.5686 23.1805 23.1805 22.5686 23.564 21.816C24 20.9603 24 19.8402 24 17.6V6.4C24 4.15979 24 3.03969 23.564 2.18404C23.1805 1.43139 22.5686 0.819467 21.816 0.435974C20.9603 0 19.8402 0 17.6 0H6.4C4.15979 0 3.03969 0 2.18404 0.435974C1.43139 0.819467 0.819467 1.43139 0.435974 2.18404ZM7.19808 11.4225L10.0038 14.2855L17.1291 7.02152L18.0778 7.98959L10.0038 16.2285L6.24266 12.3905L7.19808 11.4225Z"
        }
      />
    ),
    viewBox: "0 0 24 24"
  },
  "chevron-right": {
    path: (
      <path
        fill={"currentColor"}
        d={"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"}
      />
    )
  },
  "chevron-left": {
    path: (
      <path
        fill={"currentColor"}
        d={"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"}
      />
    )
  },
  "chevron-left-2": {
    path: (
      <path
        clipRule={"evenodd"}
        d={"m0 11 10.5-10.5 2 2-8.5 8.5 8.5 8.5-2 2z"}
        fill={"currentColor"}
        fillRule={"evenodd"}
      />
    ),
    viewbox: "0 0 13 22"
  },
  "chevron-down": {
    path: (
      <path
        fill={"currentColor"}
        d={"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"}
      />
    )
  },
  "chevron-down-select": {
    path: (
      <path
        fill={"none"}
        d={"M1 1L8 6L15 1"}
        stroke={"currentColor"}
        strokeWidth={"1.4"}
        strokeLinecap={"round"}
      />
    ),
    viewbox: "0 0 16 7"
  },
  "chevron-up": {
    path: (
      <path
        fill={"currentColor"}
        d={"M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"}
      />
    )
  },
  close: {
    viewBox: "0 0 16 16",
    path: (
      <path
        d={
          "M1.15417 1.15417C0.831943 1.4764 0.831943 1.99937 1.15417 2.3216L6.83257 8L1.15417 13.6784C0.831943 14.0006 0.831943 14.5236 1.15417 14.8458C1.4764 15.1681 1.99937 15.1681 2.3216 14.8458L8 9.16743L13.6784 14.8458C14.0006 15.1681 14.5236 15.1681 14.8458 14.8458C15.1681 14.5236 15.1681 14.0006 14.8458 13.6784L9.16743 8L14.8458 2.3216C15.1681 1.99937 15.1681 1.4764 14.8458 1.15417C14.5236 0.831943 14.0006 0.831944 13.6784 1.15417L8 6.83257L2.3216 1.15417C1.99937 0.831943 1.4764 0.831943 1.15417 1.15417Z"
        }
        fill={"currentColor"}
        stroke={"currentColor"}
        strokeWidth={"0.175"}
      />
    )
  },
  comment: {
    path: (
      <path
        d={
          "M4 4.00024H20C20.552 4.00024 21 4.44824 21 5.00024V16.0002C21 16.5522 20.552 17.0002 20 17.0002H10.8L6 21.0002V17.0002H4C3.448 17.0002 3 16.5522 3 16.0002V5.00024C3 4.44824 3.448 4.00024 4 4.00024Z"
        }
        fill={"currentColor"}
      />
    )
  },
  "comment-2": {
    viewBox: "0 0 20 20",
    path: (
      <path
        d={
          "M16.6667 3.33334H3.33333C2.87333 3.33334 2.5 3.70667 2.5 4.16667V13.3333C2.5 13.7933 2.87333 14.1667 3.33333 14.1667H5V17.5L9 14.1667H16.6667C17.1267 14.1667 17.5 13.7933 17.5 13.3333V4.16667C17.5 3.70667 17.1267 3.33334 16.6667 3.33334ZM16.6667 13.3333H8.69167L5.83333 15.7167V13.3333H3.33333V4.16667H16.6667V13.3333Z"
        }
        fill={"currentColor"}
      />
    )
  },
  copy: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
        }
      />
    )
  },
  delete: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M20.5 6H19V5C19 4.5 18.5 4 18 4H15V3C15 2.5 14.5 2 14 2H10C9.5 2 9 2.5 9 3V4H6C5.5 4 5 4.5 5 5V6H3.5C3.2 6 3 6.2 3 6.5C3 6.8 3.2 7 3.5 7H5V21C5 21.5 5.5 22 6 22H18C18.5 22 19 21.5 19 21V7H20.5C20.8 7 21 6.8 21 6.5C21 6.2 20.8 6 20.5 6ZM10 3H14V4H10V3ZM6 5H18V6H6V5ZM18 21H6V7H18V21ZM8.5 9C8.2 9 8 9.2 8 9.5V18.5C8 18.8 8.2 19 8.5 19C8.8 19 9 18.8 9 18.5V9.5C9 9.2 8.8 9 8.5 9ZM12 9C11.7 9 11.5 9.2 11.5 9.5V18.5C11.5 18.8 11.7 19 12 19C12.3 19 12.5 18.8 12.5 18.5V9.5C12.5 9.2 12.3 9 12 9ZM15.5 9C15.2 9 15 9.2 15 9.5V18.5C15 18.8 15.2 19 15.5 19C15.8 19 16 18.8 16 18.5V9.5C16 9.2 15.8 9 15.5 9Z"
        }
      />
    )
  },
  "delete-2": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M17.0833 5.00033H15.8333V4.16699C15.8333 3.75033 15.4167 3.33366 15 3.33366H12.5V2.50033C12.5 2.08366 12.0833 1.66699 11.6667 1.66699H8.33333C7.91667 1.66699 7.5 2.08366 7.5 2.50033V3.33366H5C4.58333 3.33366 4.16667 3.75033 4.16667 4.16699V5.00033H2.91667C2.66667 5.00033 2.5 5.16699 2.5 5.41699C2.5 5.66699 2.66667 5.83366 2.91667 5.83366H4.16667V17.5003C4.16667 17.917 4.58333 18.3337 5 18.3337H15C15.4167 18.3337 15.8333 17.917 15.8333 17.5003V5.83366H17.0833C17.3333 5.83366 17.5 5.66699 17.5 5.41699C17.5 5.16699 17.3333 5.00033 17.0833 5.00033ZM8.33333 2.50033H11.6667V3.33366H8.33333V2.50033ZM5 4.16699H15V5.00033H5V4.16699ZM15 17.5003H5V5.83366H15V17.5003ZM7.08333 7.50033C6.83333 7.50033 6.66667 7.66699 6.66667 7.91699V15.417C6.66667 15.667 6.83333 15.8337 7.08333 15.8337C7.33333 15.8337 7.5 15.667 7.5 15.417V7.91699C7.5 7.66699 7.33333 7.50033 7.08333 7.50033ZM10 7.50033C9.75 7.50033 9.58333 7.66699 9.58333 7.91699V15.417C9.58333 15.667 9.75 15.8337 10 15.8337C10.25 15.8337 10.4167 15.667 10.4167 15.417V7.91699C10.4167 7.66699 10.25 7.50033 10 7.50033ZM12.9167 7.50033C12.6667 7.50033 12.5 7.66699 12.5 7.91699V15.417C12.5 15.667 12.6667 15.8337 12.9167 15.8337C13.1667 15.8337 13.3333 15.667 13.3333 15.417V7.91699C13.3333 7.66699 13.1667 7.50033 12.9167 7.50033Z"
        }
      />
    ),
    viewBox: "0 0 20 20"
  },
  download: {
    viewBox: "0 0 14 14",
    path: (
      <path
        fill={"currentColor"}
        d={
          "M11.2857,6.05714 L10.08571,4.85714 L7.85714,7.14786 L7.85714,1 L6.14286,1 L6.14286,7.14786 L3.91429,4.85714 L2.71429,6.05714 L7,10.42857 L11.2857,6.05714 Z M1,11.2857 L1,13 L13,13 L13,11.2857 L1,11.2857 Z"
        }
      />
    )
  },
  "download-2": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M9.58343 4.51628C9.58343 4.28628 9.7701 4.09961 10.0001 4.09961C10.2301 4.09961 10.4168 4.28628 10.4168 4.51628V13.2663L13.6001 10.8413C13.6701 10.7879 13.7584 10.7554 13.8543 10.7554C14.0859 10.7554 14.2734 10.9429 14.2734 11.1746C14.2734 11.3104 14.2093 11.4304 14.1093 11.5071L14.1084 11.4996L10.0001 14.6246L6.0001 11.5079C5.88926 11.4321 5.8176 11.3063 5.8176 11.1629C5.8176 10.9329 6.00426 10.7463 6.23426 10.7463C6.33926 10.7463 6.43593 10.7854 6.50926 10.8496L9.58343 13.2663V4.51628ZM15.4834 16.6663H4.51676C4.28676 16.6663 4.1001 16.8529 4.1001 17.0829C4.1001 17.3129 4.28676 17.4996 4.51676 17.4996H15.4834C15.7134 17.4996 15.9001 17.3129 15.9001 17.0829C15.9001 16.8529 15.7134 16.6663 15.4834 16.6663ZM9.58343 4.51628H10.4168C10.4168 4.28628 10.2301 4.09961 10.0001 4.09961C9.7701 4.09961 9.58343 4.28628 9.58343 4.51628Z"
        }
      />
    ),
    viewBox: "0 0 20 20"
  },
  "drag-handle": {
    viewBox: "0 0 10 10",
    path: (
      <path
        fill={"currentColor"}
        d={
          "M3,2 C2.44771525,2 2,1.55228475 2,1 C2,0.44771525 2.44771525,0 3,0 C3.55228475,0 4,0.44771525 4,1 C4,1.55228475 3.55228475,2 3,2 Z M3,6 C2.44771525,6 2,5.55228475 2,5 C2,4.44771525 2.44771525,4 3,4 C3.55228475,4 4,4.44771525 4,5 C4,5.55228475 3.55228475,6 3,6 Z M3,10 C2.44771525,10 2,9.55228475 2,9 C2,8.44771525 2.44771525,8 3,8 C3.55228475,8 4,8.44771525 4,9 C4,9.55228475 3.55228475,10 3,10 Z M7,2 C6.44771525,2 6,1.55228475 6,1 C6,0.44771525 6.44771525,0 7,0 C7.55228475,0 8,0.44771525 8,1 C8,1.55228475 7.55228475,2 7,2 Z M7,6 C6.44771525,6 6,5.55228475 6,5 C6,4.44771525 6.44771525,4 7,4 C7.55228475,4 8,4.44771525 8,5 C8,5.55228475 7.55228475,6 7,6 Z M7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 Z"
        }
      />
    )
  },
  edit: {
    path: (
      <g
        fill={"none"}
        stroke={"currentColor"}
        strokeLinecap={"round"}
        strokeWidth={"2"}
      >
        <path
          d={"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"}
        />
        <path d={"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"} />
      </g>
    )
  },
  email: {
    path: (
      <g fill={"currentColor"}>
        <path
          d={
            "M11.114,14.556a1.252,1.252,0,0,0,1.768,0L22.568,4.87a.5.5,0,0,0-.281-.849A1.966,1.966,0,0,0,22,4H2a1.966,1.966,0,0,0-.289.021.5.5,0,0,0-.281.849Z"
          }
        />
        <path
          d={
            "M23.888,5.832a.182.182,0,0,0-.2.039l-6.2,6.2a.251.251,0,0,0,0,.354l5.043,5.043a.75.75,0,1,1-1.06,1.061l-5.043-5.043a.25.25,0,0,0-.354,0l-2.129,2.129a2.75,2.75,0,0,1-3.888,0L7.926,13.488a.251.251,0,0,0-.354,0L2.529,18.531a.75.75,0,0,1-1.06-1.061l5.043-5.043a.251.251,0,0,0,0-.354l-6.2-6.2a.18.18,0,0,0-.2-.039A.182.182,0,0,0,0,6V18a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6A.181.181,0,0,0,23.888,5.832Z"
          }
        />
      </g>
    )
  },
  "external-link": {
    path: (
      <g
        fill={"none"}
        stroke={"currentColor"}
        strokeLinecap={"round"}
        strokeWidth={"2"}
      >
        <path d={"M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"} />
        <path d={"M15 3h6v6"} />
        <path d={"M10 14L21 3"} />
      </g>
    )
  },
  fullscreen: {
    path: (
      <path
        fill={"currentcolor"}
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M12.9291 0H1.71142C1.26912 0 0.910156 0.3584 0.910156 0.8V12C0.910156 12.4416 1.26912 12.8 1.71142 12.8C2.15371 12.8 2.51268 12.4416 2.51268 12V1.6H12.9291C13.3714 1.6 13.7303 1.2416 13.7303 0.8C13.7303 0.3584 13.3714 0 12.9291 0ZM32.1594 0H20.9417C20.4994 0 20.1404 0.3584 20.1404 0.8C20.1404 1.2416 20.4994 1.6 20.9417 1.6H31.3581V12C31.3581 12.4416 31.7171 12.8 32.1594 12.8C32.6017 12.8 32.9606 12.4416 32.9606 12V0.8C32.9606 0.3584 32.6017 0 32.1594 0ZM32.1594 19.2C31.7171 19.2 31.3581 19.5584 31.3581 20V30.4H20.9417C20.4994 30.4 20.1404 30.7584 20.1404 31.2C20.1404 31.6416 20.4994 32 20.9417 32H32.1594C32.6017 32 32.9606 31.6416 32.9606 31.2V20C32.9606 19.5584 32.6017 19.2 32.1594 19.2ZM1.71142 19.2C1.26912 19.2 0.910156 19.5584 0.910156 20V31.2C0.910156 31.6416 1.26912 32 1.71142 32H12.9291C13.3714 32 13.7303 31.6416 13.7303 31.2C13.7303 30.7584 13.3714 30.4 12.9291 30.4H2.51268V20C2.51268 19.5584 2.15371 19.2 1.71142 19.2Z"
        }
      />
    ),
    viewBox: "0 0 33 32"
  },
  "hamburguer-settings": {
    path: (
      <path
        d={
          "M21.5 5.49993H8.93C8.691 4.64293 7.918 4.02393 7 4.02393C6.082 4.02393 5.308 4.64193 5.073 5.48493L2.5 5.49893C2.224 5.49893 2 5.72293 2 5.99893C2 6.27493 2.224 6.49893 2.5 6.49893H5.07C5.309 7.35593 6.082 7.97493 7 7.97493C7.918 7.97493 8.692 7.35693 8.927 6.51393L21.5 6.49993C21.776 6.49993 22 6.27593 22 5.99993C22 5.72393 21.776 5.49993 21.5 5.49993ZM7 6.99993C6.448 6.99993 6 6.55193 6 5.99993C6 5.44793 6.448 4.99993 7 4.99993C7.552 4.99993 8 5.44793 8 5.99993C8 6.55193 7.552 6.99993 7 6.99993ZM21.5 17.4999H11.93C11.691 16.6429 10.918 16.0239 10 16.0239C9.082 16.0239 8.308 16.6419 8.073 17.4849L2.5 17.4989C2.224 17.4989 2 17.7229 2 17.9989C2 18.2749 2.224 18.4989 2.5 18.4989H8.07C8.309 19.3559 9.082 19.9749 10 19.9749C10.918 19.9749 11.692 19.3569 11.927 18.5139L21.5 18.4999C21.776 18.4999 22 18.2759 22 17.9999C22 17.7239 21.776 17.4999 21.5 17.4999ZM10 18.9999C9.448 18.9999 9 18.5519 9 17.9999C9 17.4479 9.448 16.9999 10 16.9999C10.552 16.9999 11 17.4479 11 17.9999C11 18.5519 10.552 18.9999 10 18.9999ZM21.5 11.4999H18.93C18.691 10.6429 17.918 10.0239 17 10.0239C16.082 10.0239 15.308 10.6419 15.073 11.4849L2.5 11.4989C2.224 11.4989 2 11.7229 2 11.9989C2 12.2749 2.224 12.4989 2.5 12.4989H15.07C15.309 13.3559 16.082 13.9749 17 13.9749C17.918 13.9749 18.692 13.3569 18.927 12.5139L21.5 12.4999C21.776 12.4999 22 12.2759 22 11.9999C22 11.7239 21.776 11.4999 21.5 11.4999ZM17 12.9999C16.448 12.9999 16 12.5519 16 11.9999C16 11.4479 16.448 10.9999 17 10.9999C17.552 10.9999 18 11.4479 18 11.9999C18 12.5519 17.552 12.9999 17 12.9999Z"
        }
        fill={"currentColor"}
      />
    )
  },
  info: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
        }
      />
    )
  },
  home: {
    path: (
      <path
        d={
          "M20.66 9.69L12 2L3.34 9.69C3.23333 9.78371 3.14784 9.89906 3.08922 10.0284C3.03059 10.1577 3.00018 10.298 3 10.44V21C3 21.2652 3.10536 21.5196 3.29289 21.7071C3.48043 21.8946 3.73478 22 4 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21V10.44C20.9998 10.298 20.9694 10.1577 20.9108 10.0284C20.8522 9.89906 20.7667 9.78371 20.66 9.69ZM10 21V15H14V21H10ZM20 21H15V15C15 14.7348 14.8946 14.4804 14.7071 14.2929C14.5196 14.1054 14.2652 14 14 14H10C9.73478 14 9.48043 14.1054 9.29289 14.2929C9.10536 14.4804 9 14.7348 9 15V21H4V10.44L12 3.34L20 10.44V21Z"
        }
        fill={"currentColor"}
      />
    )
  },
  "info-outline": {
    path: (
      <g
        fill={"currentColor"}
        stroke={"currentColor"}
        strokeLinecap={"square"}
        strokeWidth={"2"}
      >
        <circle
          cx={"12"}
          cy={"12"}
          fill={"none"}
          r={"11"}
          stroke={"currentColor"}
        />
        <line fill={"none"} x1={"11.959"} x2={"11.959"} y1={"11"} y2={"17"} />
        <circle cx={"11.959"} cy={"7"} r={"1"} stroke={"none"} />
      </g>
    )
  },
  "known-vehicle": {
    path: (
      <path
        d={
          "M0.666504 6.8206H17.3332V13.8951H0.666504V6.8206ZM3.6665 11.2C4.40288 11.2 4.99984 10.5967 4.99984 9.85251C4.99984 9.1083 4.40288 8.50499 3.6665 8.50499C2.93012 8.50499 2.33317 9.1083 2.33317 9.85251C2.33317 10.5967 2.93012 11.2 3.6665 11.2ZM14.3332 11.2C15.0696 11.2 15.6665 10.5967 15.6665 9.85251C15.6665 9.1083 15.0696 8.50499 14.3332 8.50499C13.5968 8.50499 12.9998 9.1083 12.9998 9.85251C12.9998 10.5967 13.5968 11.2 14.3332 11.2ZM6.25959 8.84187C5.74794 8.84187 5.33317 9.25664 5.33317 9.76829C5.33317 10.2799 5.74794 10.6947 6.25959 10.6947H11.5734C12.0851 10.6947 12.4998 10.2799 12.4998 9.76829C12.4998 9.25664 12.0851 8.84187 11.5734 8.84187H6.25959ZM0.666504 13.8951H3.99984V15.2497C3.99984 15.6179 3.70136 15.9163 3.33317 15.9163H1.33317C0.964981 15.9163 0.666504 15.6179 0.666504 15.2497V13.8951ZM13.9998 13.8951H17.3332V15.2497C17.3332 15.6179 17.0347 15.9163 16.6665 15.9163H14.6665C14.2983 15.9163 13.9998 15.6179 13.9998 15.2497V13.8951ZM3.39237 0.0830078H14.5641C14.7028 0.0830078 14.8271 0.168968 14.876 0.298817L17.3332 6.8206H0.666504L3.07977 0.300635C3.12818 0.169837 3.25291 0.0830078 3.39237 0.0830078ZM3.95215 1.26957L2.04224 6.48372H15.9998L14.0747 1.26957H3.95215Z"
        }
        fill={"currentColor"}
      />
    ),
    viewBox: "0 0 18 16"
  },
  like: {
    path: (
      <>
        <path
          d={
            "M19.5 8C20.328 8 21 8.671 21 9.5C21 10.034 20.72 10.499 20.3 10.765C20.424 10.983 20.5 11.231 20.5 11.5C20.5 12.033 20.22 12.499 19.8 12.765C19.924 12.982 20 13.231 20 13.5C20 14.033 19.72 14.499 19.3 14.765C19.424 14.982 19.5 15.231 19.5 15.5C19.5 16.328 18.828 17 18 17H9V8C9 8 11 7.875 11 6V4.5C11 3.671 11.672 3 12.5 3C13.328 3 14.305 3.609 14.305 5.953C14.305 6.831 14.248 7.504 14.185 8H19.5Z"
          }
          fill={"currentColor"}
        />
        <path
          d={"M8 8H3V17.5C3 17.776 3.224 18 3.5 18H8V8Z"}
          fill={"currentColor"}
        />
      </>
    )
  },
  thanks_neighborhoods: {
    viewBox: "0 0 18 15",
    path: (
      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M5 5H0V14.5C0 14.776 0.224 15 0.5 15H5V5ZM1 14H4V6H1V14ZM16.5 7H14C13.724 7 13.5 7.224 13.5 7.5C13.5 7.776 13.724 8 14 8H16C16.275 8 16.5 8.224 16.5 8.5C16.5 8.776 16.275 9 16 9H14C13.724 9 13.5 9.224 13.5 9.5C13.5 9.776 13.724 10 14 10H15.5C15.775 10 16 10.225 16 10.5C16 10.775 15.775 11 15.5 11H14C13.724 11 13.5 11.224 13.5 11.5C13.5 11.776 13.724 12 14 12H15C15.275 12 15.5 12.225 15.5 12.5C15.5 12.775 15.275 13 15 13H7V6C7.609 5.766 9 5 9 3.604V1.5C9 1.224 9.225 1 9.5 1C10.247 1 10.305 2.495 10.305 2.953C10.305 3.854 10.113 5.532 10.048 6H16.5C16.775 6 17 6.224 17 6.5C17 6.776 16.775 7 16.5 7ZM18 6.5C18 5.671 17.328 5 16.5 5H11.185C11.248 4.504 11.305 3.831 11.305 2.953C11.305 0.609 10.328 0 9.5 0C8.672 0 8 0.671 8 1.5V3C8 4.875 6 5 6 5V14H15C15.828 14 16.5 13.328 16.5 12.5C16.5 12.231 16.424 11.982 16.3 11.765C16.72 11.499 17 11.033 17 10.5C17 10.231 16.924 9.982 16.8 9.765C17.22 9.499 17.5 9.033 17.5 8.5C17.5 8.231 17.424 7.983 17.3 7.765C17.72 7.499 18 7.034 18 6.5Z"
        }
        fill={"currentColor"}
      />
    )
  },
  link: {
    path: (
      <g fill={"currentColor"}>
        <path
          d={
            "M10.458,18.374,7.721,21.11a2.853,2.853,0,0,1-3.942,0l-.892-.891a2.787,2.787,0,0,1,0-3.941l5.8-5.8a2.789,2.789,0,0,1,3.942,0l.893.892A1,1,0,0,0,14.94,9.952l-.893-.892a4.791,4.791,0,0,0-6.771,0l-5.8,5.8a4.787,4.787,0,0,0,0,6.77l.892.891a4.785,4.785,0,0,0,6.771,0l2.736-2.735a1,1,0,1,0-1.414-1.415Z"
          }
        />
        <path
          d={
            "M22.526,2.363l-.892-.892a4.8,4.8,0,0,0-6.77,0l-2.905,2.9a1,1,0,0,0,1.414,1.414l2.9-2.9a2.79,2.79,0,0,1,3.941,0l.893.893a2.786,2.786,0,0,1,0,3.942l-5.8,5.8a2.769,2.769,0,0,1-1.971.817h0a2.766,2.766,0,0,1-1.969-.816,1,1,0,1,0-1.415,1.412,4.751,4.751,0,0,0,3.384,1.4h0a4.752,4.752,0,0,0,3.385-1.4l5.8-5.8a4.786,4.786,0,0,0,0-6.771Z"
          }
        />
      </g>
    )
  },
  lock: {
    viewBox: "0 0 16 16",
    path: (
      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M12 5.66667H11.3333V4.33333C11.3333 2.49333 9.83999 1 7.99999 1C6.15999 1 4.66666 2.49333 4.66666 4.33333V5.66667H3.99999C3.26666 5.66667 2.66666 6.26667 2.66666 7V13.6667C2.66666 14.4 3.26666 15 3.99999 15H12C12.7333 15 13.3333 14.4 13.3333 13.6667V7C13.3333 6.26667 12.7333 5.66667 12 5.66667ZM7.99999 11.6667C7.26666 11.6667 6.66666 11.0667 6.66666 10.3333C6.66666 9.6 7.26666 9 7.99999 9C8.73332 9 9.33332 9.6 9.33332 10.3333C9.33332 11.0667 8.73332 11.6667 7.99999 11.6667ZM5.93336 5.66666H10.0667V4.33333C10.0667 3.19333 9.14002 2.26666 8.00002 2.26666C6.86002 2.26666 5.93336 3.19333 5.93336 4.33333V5.66666Z"
        }
        fill={"currentColor"}
      />
    )
  },
  logo: {
    path: (
      <g fill={"none"}>
        <path
          d={
            "M16.1597 0C7.23956 0 0 7.168 0 16C0 24.832 7.23956 32 16.1597 32C25.0799 32 32.3194 24.832 32.3194 16C32.3194 7.168 25.0799 0 16.1597 0ZM16.1597 30.4C8.13373 30.4 1.61597 23.9467 1.61597 16C1.61597 8.05333 8.13373 1.6 16.1597 1.6C24.1857 1.6 30.7035 8.05333 30.7035 16C30.7035 23.9467 24.1857 30.4 16.1597 30.4Z"
          }
          fill={"currentColor"}
        />
        <path
          d={
            "M16.1595 3.59473C9.24315 3.59473 3.64111 9.14141 3.64111 15.9894C3.64111 19.3921 5.03084 22.4854 7.27168 24.7254C6.92691 23.8187 6.57142 22.6347 6.57142 21.6427C6.57142 19.7121 9.1031 19.0827 10.4713 18.7947C10.1696 21.2801 10.6006 23.7334 11.5917 25.9521C11.6456 26.0694 11.8179 26.0161 11.7964 25.8987C11.4732 23.6054 11.387 21.0347 11.6671 19.1254C12.0118 16.7681 14.6297 16.8214 16.1056 16.8214C17.5708 16.8214 20.2964 16.7681 20.6411 19.1254C20.9212 21.0347 20.835 23.6054 20.5119 25.8987C20.4903 26.0161 20.6627 26.0694 20.7165 25.9521C21.7077 23.7334 22.1386 21.2907 21.837 18.7947C23.2051 19.0827 25.7368 19.7121 25.7368 21.6427C25.7368 21.7707 25.7261 21.8987 25.7261 22.0267C25.7261 22.0801 25.7153 22.1227 25.7045 22.1761C25.6937 22.2614 25.6937 22.3361 25.6722 22.4214C25.6614 22.4854 25.6506 22.5494 25.6398 22.6027C25.6291 22.6774 25.6183 22.7414 25.6075 22.8161C25.5968 22.8801 25.586 22.9334 25.5645 22.9974C25.5429 23.0721 25.5321 23.1467 25.5106 23.2214C25.489 23.2854 25.4783 23.3494 25.4567 23.4241C25.4352 23.4881 25.4244 23.5627 25.4029 23.6267C25.3813 23.7014 25.3597 23.7867 25.3274 23.8614C25.3167 23.9147 25.2951 23.9681 25.2844 24.0214C25.252 24.1281 25.2089 24.2347 25.1766 24.3414C25.1658 24.3627 25.1658 24.3734 25.1551 24.3947C25.112 24.5121 25.0689 24.6294 25.0258 24.7361C25.0258 24.7361 25.0258 24.7361 25.0258 24.7467C27.2774 22.5067 28.6671 19.4241 28.6671 16.0107C28.6779 9.14141 23.0759 3.59473 16.1595 3.59473ZM9.88952 17.0881C8.55365 17.0881 7.46558 16.0107 7.46558 14.6881C7.46558 13.3654 8.55365 12.2881 9.88952 12.2881C11.2254 12.2881 12.3135 13.3654 12.3135 14.6881C12.3135 16.0107 11.2254 17.0881 9.88952 17.0881ZM16.1595 15.1894C14.5974 15.1894 13.3369 13.9307 13.3369 12.3947C13.3369 10.8481 14.6082 9.60008 16.1595 9.60008C17.7216 9.60008 18.982 10.8587 18.982 12.3947C18.982 13.9414 17.7108 15.1894 16.1595 15.1894ZM22.7957 17.0881C21.4599 17.0881 20.3718 16.0107 20.3718 14.6881C20.3718 13.3654 21.4599 12.2881 22.7957 12.2881C24.1316 12.2881 25.2197 13.3654 25.2197 14.6881C25.2197 16.0107 24.1316 17.0881 22.7957 17.0881Z"
          }
          fill={"currentColor"}
        />
      </g>
    ),
    viewBox: "0 0 33 32"
  },
  marker: {
    path: (
      <>
        <path
          d={
            "M12 10C12.8284 10 13.5 9.32843 13.5 8.5C13.5 7.67157 12.8284 7 12 7C11.1716 7 10.5 7.67157 10.5 8.5C10.5 9.32843 11.1716 10 12 10Z"
          }
          fill={"currentColor"}
        />
        <path
          d={
            "M12 3C13.4579 3.00264 14.8553 3.58295 15.8862 4.61383C16.917 5.64471 17.4974 7.04212 17.5 8.5C17.5 10.84 14.06 16.84 12 20.14C9.94 16.84 6.5 10.84 6.5 8.5C6.50264 7.04212 7.08295 5.64471 8.11383 4.61383C9.14471 3.58295 10.5421 3.00264 12 3ZM12 2C10.2761 2 8.62279 2.68482 7.40381 3.90381C6.18482 5.12279 5.5 6.77609 5.5 8.5C5.5 12.09 12 22 12 22C12 22 18.5 12.09 18.5 8.5C18.5 6.77609 17.8152 5.12279 16.5962 3.90381C15.3772 2.68482 13.7239 2 12 2Z"
          }
          fill={"currentColor"}
        />
      </>
    )
  },
  minus: {
    path: (
      <g fill={"currentColor"}>
        <rect height={"4"} width={"20"} x={"2"} y={"10"} />
      </g>
    )
  },
  moon: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M21.4,13.7C20.6,13.9,19.8,14,19,14c-5,0-9-4-9-9c0-0.8,0.1-1.6,0.3-2.4c0.1-0.3,0-0.7-0.3-1 c-0.3-0.3-0.6-0.4-1-0.3C4.3,2.7,1,7.1,1,12c0,6.1,4.9,11,11,11c4.9,0,9.3-3.3,10.6-8.1c0.1-0.3,0-0.7-0.3-1 C22.1,13.7,21.7,13.6,21.4,13.7z"
        }
      />
    )
  },
  more: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M8 12C8 13.105 7.105 14 6 14C4.895 14 4 13.105 4 12C4 10.895 4.895 10 6 10C7.105 10 8 10.895 8 12ZM14 12C14 13.105 13.105 14 12 14C10.895 14 10 13.105 10 12C10 10.895 10.895 10 12 10C13.105 10 14 10.895 14 12ZM20 12C20 13.105 19.105 14 18 14C16.895 14 16 13.105 16 12C16 10.895 16.895 10 18 10C19.105 10 20 10.895 20 12Z"
        }
      />
    )
  },
  "not-allowed": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
        }
      />
    )
  },
  "outline-check": {
    path: (
      <g fill={"currentColor"}>
        <path
          fillRule={"evenodd"}
          clipRule={"evenodd"}
          d={
            "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM17.85 8.85L9.66 17L6.16 13.5C6.069 13.409 6.013 13.284 6.013 13.145C6.013 12.868 6.238 12.643 6.515 12.643C6.654 12.643 6.779 12.699 6.87 12.79L9.69 15.61L17.16 8.14C17.251 8.049 17.376 7.993 17.515 7.993C17.792 7.993 18.017 8.218 18.017 8.495C18.017 8.634 17.961 8.759 17.87 8.85H17.85Z"
          }
          fill={"currentColor"}
        />
      </g>
    ),
    viewBox: "0 0 27 27"
  },
  pause: {
    path: (
      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M0 34C0 35.1046 0.895431 36 2 36H8C9.10457 36 10 35.1046 10 34V2C10 0.895432 9.10457 0 8 0H2C0.89543 0 0 0.895431 0 2V34ZM20 0C18.8954 0 18 0.895431 18 2V34C18 35.1046 18.8954 36 20 36H26C27.1046 36 28 35.1046 28 34V2C28 0.895432 27.1046 0 26 0H20Z"
        }
        fill={"white"}
      />
    ),
    viewBox: "0 0 28 36"
  },
  play: {
    path: (
      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M1.54076 0.990487C0.875246 0.562658 0 1.0405 0 1.83167V34.1683C0 34.9595 0.875246 35.4373 1.54076 35.0095L26.6915 18.8412C27.3038 18.4475 27.3038 17.5525 26.6915 17.1588L1.54076 0.990487Z"
        }
        fill={"currentColor"}
      />
    ),
    viewBox: "0 0 28 36"
  },
  "plus-square": {
    path: (
      <g
        fill={"none"}
        stroke={"currentColor"}
        strokeLinecap={"round"}
        strokeWidth={"2"}
      >
        <rect height={"18"} width={"18"} rx={"2"} ry={"2"} x={"3"} y={"3"} />
        <path d={"M12 8v8"} />
        <path d={"M8 12h8"} />
      </g>
    )
  },
  question: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,19a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,1,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,9.255a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z"
        }
      />
    )
  },
  "question-outline": {
    path: (
      <g stroke={"currentColor"} strokeWidth={"1.5"}>
        <path
          strokeLinecap={"round"}
          fill={"none"}
          d={"M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"}
        />
        <path
          fill={"none"}
          strokeLinecap={"round"}
          d={"M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"}
        />
        <circle
          fill={"none"}
          strokeMiterlimit={"10"}
          cx={"12"}
          cy={"12"}
          r={"11.25"}
        />
      </g>
    )
  },
  repeat: {
    path: (
      <g fill={"currentColor"}>
        <path
          d={
            "M10.319,4.936a7.239,7.239,0,0,1,7.1,2.252,1.25,1.25,0,1,0,1.872-1.657A9.737,9.737,0,0,0,9.743,2.5,10.269,10.269,0,0,0,2.378,9.61a.249.249,0,0,1-.271.178l-1.033-.13A.491.491,0,0,0,.6,9.877a.5.5,0,0,0-.019.526l2.476,4.342a.5.5,0,0,0,.373.248.43.43,0,0,0,.062,0,.5.5,0,0,0,.359-.152l3.477-3.593a.5.5,0,0,0-.3-.844L5.15,10.172a.25.25,0,0,1-.2-.333A7.7,7.7,0,0,1,10.319,4.936Z"
          }
        />
        <path
          d={
            "M23.406,14.1a.5.5,0,0,0,.015-.526l-2.5-4.329A.5.5,0,0,0,20.546,9a.489.489,0,0,0-.421.151l-3.456,3.614a.5.5,0,0,0,.3.842l1.848.221a.249.249,0,0,1,.183.117.253.253,0,0,1,.023.216,7.688,7.688,0,0,1-5.369,4.9,7.243,7.243,0,0,1-7.1-2.253,1.25,1.25,0,1,0-1.872,1.656,9.74,9.74,0,0,0,9.549,3.03,10.261,10.261,0,0,0,7.369-7.12.251.251,0,0,1,.27-.179l1.058.127a.422.422,0,0,0,.06,0A.5.5,0,0,0,23.406,14.1Z"
          }
        />
      </g>
    )
  },
  "repeat-clock": {
    path: (
      <g fill={"currentColor"}>
        <path
          d={
            "M12.965,6a1,1,0,0,0-1,1v5.5a1,1,0,0,0,1,1h5a1,1,0,0,0,0-2h-3.75a.25.25,0,0,1-.25-.25V7A1,1,0,0,0,12.965,6Z"
          }
        />
        <path
          d={
            "M12.567,1.258A10.822,10.822,0,0,0,2.818,8.4a.25.25,0,0,1-.271.163L.858,8.309a.514.514,0,0,0-.485.213.5.5,0,0,0-.021.53l2.679,4.7a.5.5,0,0,0,.786.107l3.77-3.746a.5.5,0,0,0-.279-.85L5.593,9.007a.25.25,0,0,1-.192-.35,8.259,8.259,0,1,1,7.866,11.59,1.25,1.25,0,0,0,.045,2.5h.047a10.751,10.751,0,1,0-.792-21.487Z"
          }
        />
      </g>
    )
  },
  "ring-logo": {
    viewBox: "0 0 51 32",
    path: (
      <g fill={"currentColor"}>
        <path
          d={
            "M14.4182 3.46569C15.3697 3.46569 16.1412 2.68987 16.1412 1.73284C16.1412 0.775821 15.3697 0 14.4182 0C13.4666 0 12.6952 0.775821 12.6952 1.73284C12.6952 2.68987 13.4666 3.46569 14.4182 3.46569Z"
          }
          fill={"#1998D5"}
        />
        <path
          d={
            "M10.3867 8.28972C10.3877 8.55842 10.278 8.81554 10.0837 8.99991C9.88825 9.19692 9.62078 9.30434 9.34416 9.29689C9.07889 9.28893 8.82652 9.18002 8.63801 8.99216L8.60463 8.95859C8.58481 8.9384 8.56235 8.92103 8.53787 8.90694C8.51202 8.89378 8.48858 8.87631 8.46854 8.85529C7.74076 8.25459 6.82408 7.93416 5.88275 7.95142C4.67246 7.95142 3.7258 8.36806 3.04276 9.20134C2.35972 10.0346 2.01735 11.2174 2.01564 12.7497V23.7433C2.03662 24.0338 1.91829 24.3169 1.69723 24.5051C1.50429 24.6684 1.26119 24.7596 1.00906 24.7634C0.756925 24.7596 0.513821 24.6684 0.320883 24.5051C0.0994738 24.3172 -0.0189309 24.0339 0.00247474 23.7433V12.7497C-0.00432097 11.8521 0.120269 10.9585 0.372239 10.0975C0.600297 9.31189 0.976947 8.57796 1.48153 7.93592C1.97427 7.31135 2.59987 6.80572 3.31238 6.45616C4.11564 6.08 4.99436 5.89529 5.88019 5.91642C6.63972 5.9296 7.3909 6.07824 8.09877 6.35545C8.82803 6.61483 9.49288 7.02976 10.0477 7.57179C10.254 7.75407 10.3766 8.01373 10.3867 8.28972Z"
          }
          fill={"#535556"}
        />
        <path
          d={
            "M15.4247 23.7433C15.4457 24.0338 15.3274 24.3169 15.1063 24.5051C14.7086 24.8445 14.1251 24.8445 13.7274 24.5051C13.506 24.3172 13.3876 24.0339 13.409 23.7433V7.27484C13.388 6.98432 13.5063 6.70121 13.7274 6.51301C14.1255 6.1747 14.7082 6.1747 15.1063 6.51301C15.327 6.70146 15.4453 6.98439 15.4247 7.27484V23.7433Z"
          }
          fill={"#535556"}
        />
        <path
          d={
            "M32.9012 23.7433C32.9216 24.0343 32.8023 24.3175 32.5802 24.5051C32.183 24.8431 31.6012 24.8431 31.2039 24.5051C30.9825 24.3172 30.8641 24.0339 30.8855 23.7433V12.5147C30.8897 11.9051 30.7691 11.3012 30.5311 10.7405C30.069 9.64484 29.2017 8.77258 28.1123 8.30782C26.9832 7.83494 25.7132 7.83494 24.5841 8.30782C23.4948 8.7728 22.6276 9.64499 22.1652 10.7405C21.9287 11.3015 21.8089 11.9053 21.8134 12.5147V23.7433C21.8348 24.0339 21.7164 24.3172 21.495 24.5051C21.0973 24.8445 20.5138 24.8445 20.1161 24.5051C19.8947 24.3172 19.7763 24.0339 19.7977 23.7433V12.5147C19.7912 11.6317 19.966 10.7569 20.3113 9.94511C20.6384 9.16284 21.1117 8.45097 21.7056 7.84814C22.2971 7.25564 22.9939 6.77999 23.7598 6.44585C25.4007 5.74461 27.2546 5.74461 28.8954 6.44585C30.4683 7.10355 31.7183 8.3607 32.3723 9.94253C32.7171 10.7545 32.8919 11.6292 32.8858 12.5121L32.9012 23.7433Z"
          }
          fill={"#535556"}
        />
        <path
          fillRule={"evenodd"}
          clipRule={"evenodd"}
          d={
            "M49.5226 27.5086C49.8701 26.6929 50.045 25.8134 50.0362 24.9261H50.0259V12.5121C50.032 11.6292 49.8572 10.7545 49.5123 9.94253C48.8586 8.36054 47.6085 7.10331 46.0355 6.44585C44.3947 5.74461 42.5408 5.74461 40.8999 6.44585C40.134 6.77999 39.4372 7.25564 38.8457 7.84813C38.2514 8.45068 37.7781 9.16262 37.4514 9.94511C37.1061 10.7569 36.9312 11.6317 36.9378 12.5147V17.8475C36.9284 18.7349 37.1033 19.6145 37.4514 20.43C38.1136 21.9973 39.3544 23.2452 40.9128 23.9112C41.7237 24.2609 42.5982 24.4368 43.4806 24.4277C44.3332 24.4312 45.1781 24.2644 45.9662 23.937C46.7285 23.626 47.4254 23.173 48.0205 22.6018V24.9261C48.0194 25.5331 47.8944 26.1334 47.6533 26.6899C47.1911 27.7856 46.3238 28.6578 45.2344 29.1226C44.6769 29.3617 44.0764 29.483 43.4703 29.479C42.8027 29.4757 42.1398 29.3668 41.5059 29.1562C40.8671 28.9565 40.2928 28.5892 39.842 28.0922L39.7085 27.9553C39.6887 27.9385 39.6766 27.9142 39.6751 27.8882C39.5879 27.7306 39.4517 27.6063 39.2873 27.5344C39.1543 27.48 39.0124 27.4511 38.8688 27.4492C38.6004 27.4493 38.3422 27.5528 38.1472 27.7384C37.9384 27.9201 37.8215 28.1864 37.8288 28.4641C37.8223 28.669 37.8807 28.8707 37.9957 29.04C38.2807 29.4618 38.6391 29.8283 39.0537 30.122C39.4907 30.4367 39.964 30.6969 40.4634 30.8968C40.9613 31.098 41.4772 31.2511 42.0041 31.3539C42.4911 31.4525 42.9864 31.5035 43.4831 31.5062C44.361 31.5122 45.2307 31.3364 46.0381 30.9897C47.6081 30.3331 48.8593 29.0831 49.5226 27.5086ZM47.6661 10.7405C47.904 11.3012 48.0247 11.9051 48.0205 12.5147V17.8191C48.0241 18.4336 47.9008 19.0421 47.6584 19.6062C47.1963 20.7019 46.329 21.5741 45.2395 22.0389C44.1105 22.5118 42.8404 22.5118 41.7114 22.0389C41.171 21.8099 40.68 21.4774 40.2657 21.0601C39.8507 20.6429 39.5194 20.1493 39.2899 19.6062C39.052 19.0411 38.9323 18.4328 38.9381 17.8191V12.5121C38.9341 11.9028 39.0538 11.2991 39.2899 10.7379C39.7555 9.64162 40.6265 8.77022 41.7191 8.30782C42.8481 7.83494 44.1182 7.83494 45.2472 8.30782C46.3367 8.77258 47.204 9.64484 47.6661 10.7405Z"
          }
          fill={"#535556"}
        />
      </g>
    )
  },
  search: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M23.384,21.619,16.855,15.09a9.284,9.284,0,1,0-1.768,1.768l6.529,6.529a1.266,1.266,0,0,0,1.768,0A1.251,1.251,0,0,0,23.384,21.619ZM2.75,9.5a6.75,6.75,0,1,1,6.75,6.75A6.758,6.758,0,0,1,2.75,9.5Z"
        }
      />
    )
  },
  "search-2": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M23.414,20.591l-4.645-4.645a10.256,10.256,0,1,0-2.828,2.829l4.645,4.644a2.025,2.025,0,0,0,2.828,0A2,2,0,0,0,23.414,20.591ZM10.25,3.005A7.25,7.25,0,1,1,3,10.255,7.258,7.258,0,0,1,10.25,3.005Z"
        }
      />
    )
  },
  settings: {
    viewBox: "0 0 14 14",
    path: (
      <path
        fill={"currentColor"}
        d={
          "M14,7.77 L14,6.17 L12.06,5.53 L11.61,4.44 L12.49,2.6 L11.36,1.47 L9.55,2.38 L8.46,1.93 L7.77,0.01 L6.17,0.01 L5.54,1.95 L4.43,2.4 L2.59,1.52 L1.46,2.65 L2.37,4.46 L1.92,5.55 L0,6.23 L0,7.82 L1.94,8.46 L2.39,9.55 L1.51,11.39 L2.64,12.52 L4.45,11.61 L5.54,12.06 L6.23,13.98 L7.82,13.98 L8.45,12.04 L9.56,11.59 L11.4,12.47 L12.53,11.34 L11.61,9.53 L12.08,8.44 L14,7.75 L14,7.77 Z M7,10 C5.34,10 4,8.66 4,7 C4,5.34 5.34,4 7,4 C8.66,4 10,5.34 10,7 C10,8.66 8.66,10 7,10 Z"
        }
      />
    )
  },
  share: {
    path: (
      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M7.45851 11.1278L7.50886 11.0949C9.69182 9.6967 12.3486 8.80685 15.2157 8.65813L15.2544 5L23 12.3138L15.2544 18.4087V14.7518C15.2544 14.7518 13.5891 14.3983 9.44525 15.3613C6.22826 16.3742 3.44244 17.826 1 19.6667L1.05422 19.6264C2.18507 16.0975 4.45711 13.1635 7.45851 11.1278Z"
        }
        fill={"currentColor"}
      />
    )
  },
  "share-2": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M13.6882 8.18302L12.7327 8.23259C10.5773 8.34439 8.52544 9.003 6.81485 10.0986L6.78027 10.1212C5.39221 11.0639 4.22246 12.243 3.3207 13.6018C4.65815 12.8916 6.09166 12.2953 7.64066 11.8093C9.93073 11.2771 11.5637 11.1469 12.6215 11.2537C12.756 11.2673 12.8562 11.2828 12.9237 11.2972L13.7307 11.4685V13.2434L17.609 10.1917L13.706 6.50624L13.6882 8.18302ZM0.833496 16.3892C0.848603 16.3778 0.863726 16.3665 0.878864 16.3551C0.878802 16.3553 0.833496 16.3892 0.833496 16.3892ZM6.21559 9.27347L6.25755 9.24604C8.07668 8.08091 10.2906 7.33937 12.6799 7.21544L12.7122 4.16699L19.1668 10.2619L12.7122 15.3409V12.2935C12.7122 12.2935 11.3244 11.9989 7.87121 12.8014C5.21028 13.6392 2.90334 14.8374 0.878864 16.3551C1.8213 13.4146 3.71458 10.9698 6.21559 9.27347Z"
        }
      />
    ),
    viewBox: "0 0 20 20"
  },
  "small-add": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M14 9h-3V6c0-.55-.45-1-1-1s-1 .45-1 1v3H6c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1z"
        }
        fillRule={"evenodd"}
      />
    ),
    viewBox: "0 0 20 20"
  },
  "small-close": {
    path: (
      <path
        d={
          "M9.41 8l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 0 0-1.71-.71L8 6.59l-2.29-2.3a1.003 1.003 0 0 0-1.42 1.42L6.59 8 4.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 0 0 1.71.71L8 9.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 0 0 .71-1.71L9.41 8z"
        }
        fillRule={"evenodd"}
        fill={"currentColor"}
      />
    ),
    viewBox: "0 0 16 16"
  },
  spinner: {
    path: (
      <>
        <defs>
          <linearGradient
            x1={"28.154%"}
            y1={"63.74%"}
            x2={"74.629%"}
            y2={"17.783%"}
            id={"a"}
          >
            <stop stopColor={"currentColor"} offset={"0%"} />
            <stop stopColor={"#fff"} stopOpacity={"0"} offset={"100%"} />
          </linearGradient>
        </defs>
        <g transform={"translate(2)"} fill={"none"}>
          <circle
            stroke={"url(#a)"}
            strokeWidth={"4"}
            cx={"10"}
            cy={"12"}
            r={"10"}
          />
          <path
            d={"M10 2C4.477 2 0 6.477 0 12"}
            stroke={"currentColor"}
            strokeWidth={"4"}
          />
          <rect
            fill={"currentColor"}
            x={"8"}
            width={"4"}
            height={"4"}
            rx={"8"}
          />
        </g>
      </>
    )
  },
  star: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M23.555,8.729a1.505,1.505,0,0,0-1.406-.98H16.062a.5.5,0,0,1-.472-.334L13.405,1.222a1.5,1.5,0,0,0-2.81,0l-.005.016L8.41,7.415a.5.5,0,0,1-.471.334H1.85A1.5,1.5,0,0,0,.887,10.4l5.184,4.3a.5.5,0,0,1,.155.543L4.048,21.774a1.5,1.5,0,0,0,2.31,1.684l5.346-3.92a.5.5,0,0,1,.591,0l5.344,3.919a1.5,1.5,0,0,0,2.312-1.683l-2.178-6.535a.5.5,0,0,1,.155-.543l5.194-4.306A1.5,1.5,0,0,0,23.555,8.729Z"
        }
      />
    )
  },
  "star-2": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M9.99984 3.78366L11.7332 7.83366L11.9498 8.34199H16.4498L13.1998 11.917L13.3915 12.4003L15.0582 16.617L10.3498 14.267L9.99984 14.067L9.62484 14.2503L4.92484 16.6087L6.78317 11.9087L6.43317 11.5253L3.54984 8.33366H8.04984L8.2665 7.82533L9.99984 3.78366ZM9.99984 1.66699L7.49984 7.50033H1.6665L5.83317 12.0837L3.33317 18.3337L9.99984 15.0003L16.6665 18.3337L14.1665 12.0837L18.3332 7.50033H12.4998L9.99984 1.66699Z"
        }
      />
    ),
    viewBox: "0 0 20 20"
  },
  square: {
    path: (
      <path
        stroke={"currentcolor"}
        fill={"none"}
        d={
          "M0.5 6.4C0.5 5.27164 0.500389 4.45545 0.552836 3.81352C0.604807 3.17744 0.705391 2.75662 0.881477 2.41103C1.21703 1.75247 1.75247 1.21703 2.41103 0.881477C2.75662 0.705391 3.17744 0.604807 3.81352 0.552836C4.45545 0.500389 5.27165 0.5 6.4 0.5H17.6C18.7284 0.5 19.5446 0.500389 20.1865 0.552836C20.8226 0.604807 21.2434 0.705391 21.589 0.881477C22.2475 1.21703 22.783 1.75247 23.1185 2.41103C23.2946 2.75662 23.3952 3.17744 23.4472 3.81352C23.4996 4.45545 23.5 5.27165 23.5 6.4V17.6C23.5 18.7284 23.4996 19.5446 23.4472 20.1865C23.3952 20.8226 23.2946 21.2434 23.1185 21.589C22.783 22.2475 22.2475 22.783 21.589 23.1185C21.2434 23.2946 20.8226 23.3952 20.1865 23.4472C19.5446 23.4996 18.7284 23.5 17.6 23.5H6.4C5.27164 23.5 4.45545 23.4996 3.81352 23.4472C3.17744 23.3952 2.75662 23.2946 2.41103 23.1185C1.75247 22.783 1.21703 22.2475 0.881477 21.589C0.705391 21.2434 0.604807 20.8226 0.552836 20.1865C0.500389 19.5446 0.5 18.7284 0.5 17.6V6.4Z"
        }
      />
    ),
    viewBox: "0 0 24 24"
  },
  sun: {
    path: (
      <g
        strokeLinejoin={"round"}
        strokeLinecap={"round"}
        strokeWidth={"2"}
        fill={"none"}
        stroke={"currentColor"}
      >
        <circle cx={"12"} cy={"12"} r={"5"} />
        <path d={"M12 1v2"} />
        <path d={"M12 21v2"} />
        <path d={"M4.22 4.22l1.42 1.42"} />
        <path d={"M18.36 18.36l1.42 1.42"} />
        <path d={"M1 12h2"} />
        <path d={"M21 12h2"} />
        <path d={"M4.22 19.78l1.42-1.42"} />
        <path d={"M18.36 5.64l1.42-1.42"} />
      </g>
    )
  },
  unlock: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M19.5,9.5h-.75V6.75A6.751,6.751,0,0,0,5.533,4.811a1.25,1.25,0,1,0,2.395.717A4.251,4.251,0,0,1,16.25,6.75V9a.5.5,0,0,1-.5.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5Z"
        }
      />
    )
  },
  view: {
    path: (
      <g fill={"currentColor"}>
        <path
          d={
            "M23.432,10.524C20.787,7.614,16.4,4.538,12,4.6,7.6,4.537,3.213,7.615.568,10.524a2.211,2.211,0,0,0,0,2.948C3.182,16.351,7.507,19.4,11.839,19.4h.308c4.347,0,8.671-3.049,11.288-5.929A2.21,2.21,0,0,0,23.432,10.524ZM7.4,12A4.6,4.6,0,1,1,12,16.6,4.6,4.6,0,0,1,7.4,12Z"
          }
        />
        <circle cx={"12"} cy={"12"} r={"2"} />
      </g>
    )
  },
  verified: {
    path: (
      <g fill={"currentColor"}>
        <path
          fillRule={"evenodd"}
          clipRule={"evenodd"}
          d={
            "M21.62 10.1298C22.0617 10.5087 22.1319 11.1662 21.78 11.6298L21.48 11.9998C21.0962 12.5447 21.0278 13.2514 21.3 13.8598L21.51 14.2898C21.756 14.8187 21.5507 15.4479 21.04 15.7298L20.62 15.9598C20.0852 16.2866 19.7536 16.8632 19.74 17.4898V17.9798C19.7528 18.5579 19.3159 19.0474 18.74 19.0998H18.27C17.6548 19.1698 17.1168 19.546 16.84 20.0998L16.65 20.5498C16.428 21.0849 15.8262 21.3528 15.28 21.1598L14.83 20.9998C14.2279 20.8196 13.5756 20.9591 13.1 21.3698L12.75 21.6998C12.3294 22.0985 11.6705 22.0985 11.25 21.6998L10.9 21.3698C10.4243 20.9591 9.77197 20.8196 9.16995 20.9998L8.75995 21.0798C8.21375 21.2728 7.61196 21.0049 7.38996 20.4698L7.19995 20.0198C6.92313 19.466 6.38509 19.0898 5.76995 19.0198H5.29995C4.72404 18.9674 4.28706 18.4779 4.29995 17.8998V17.4098C4.28634 16.7832 3.95472 16.2066 3.41995 15.8798L2.99995 15.6498C2.47416 15.3817 2.25009 14.749 2.48995 14.2098L2.69995 13.7798C2.93876 13.1967 2.87126 12.5329 2.51995 12.0098L2.21995 11.6298C1.86806 11.1662 1.93819 10.5087 2.37995 10.1298L2.73995 9.80979C3.19954 9.38134 3.40719 8.74708 3.28995 8.12979L3.17995 7.64979C3.04961 7.08671 3.37725 6.5188 3.92995 6.34979L4.38996 6.20979C4.99572 6.01065 5.45414 5.51055 5.59995 4.88979L5.68995 4.40979C5.80117 3.84078 6.33493 3.45578 6.90996 3.52979L7.37995 3.58979C8.00695 3.63912 8.61641 3.36825 8.99995 2.86979L9.20995 2.46979C9.5421 1.99583 10.1847 1.86032 10.68 2.15979L11.08 2.40979C11.6352 2.71029 12.3047 2.71029 12.86 2.40979L13.26 2.15979C13.7552 1.86032 14.3978 1.99583 14.73 2.46979L15 2.86979C15.3894 3.3777 16.0127 3.64967 16.65 3.58979L17.12 3.52979C17.695 3.45578 18.2287 3.84078 18.34 4.40979L18.43 4.88979C18.5701 5.50345 19.0158 6.00201 19.61 6.20979L20.07 6.34979C20.6227 6.5188 20.9503 7.08671 20.82 7.64979L20.71 8.12979C20.5927 8.74708 20.8004 9.38134 21.26 9.80979L21.62 10.1298ZM10.63 15.5799L16.35 9.84988L16.36 9.86988C16.5533 9.67658 16.5533 9.36318 16.36 9.16988C16.1667 8.97658 15.8533 8.97658 15.66 9.16988L10.66 14.1699L7.99995 11.5099C7.87313 11.3777 7.68541 11.3232 7.50752 11.3669C7.32962 11.4107 7.18858 11.546 7.13752 11.7219C7.08645 11.8979 7.13313 12.0877 7.25995 12.2199L10.63 15.5799Z"
          }
          fill={"currentColor"}
        />
      </g>
    ),
    viewBox: "0 0 24 24"
  },
  "view-off": {
    path: (
      <g fill={"currentColor"}>
        <path
          d={
            "M23.2,10.549a20.954,20.954,0,0,0-4.3-3.6l4-3.995a1,1,0,1,0-1.414-1.414l-.018.018a.737.737,0,0,1-.173.291l-19.5,19.5c-.008.007-.018.009-.026.017a1,1,0,0,0,1.631,1.088l4.146-4.146a11.26,11.26,0,0,0,4.31.939h.3c4.256,0,8.489-2.984,11.051-5.8A2.171,2.171,0,0,0,23.2,10.549ZM16.313,13.27a4.581,4.581,0,0,1-3,3.028,4.3,4.3,0,0,1-3.1-.19.253.253,0,0,1-.068-.407l5.56-5.559a.252.252,0,0,1,.407.067A4.3,4.3,0,0,1,16.313,13.27Z"
          }
        />
        <path
          d={
            "M7.615,13.4a.244.244,0,0,0,.061-.24A4.315,4.315,0,0,1,7.5,12,4.5,4.5,0,0,1,12,7.5a4.276,4.276,0,0,1,1.16.173.244.244,0,0,0,.24-.062l1.941-1.942a.254.254,0,0,0-.1-.421A10.413,10.413,0,0,0,12,4.75C7.7,4.692,3.4,7.7.813,10.549a2.15,2.15,0,0,0-.007,2.9,21.209,21.209,0,0,0,3.438,3.03.256.256,0,0,0,.326-.029Z"
          }
        />
      </g>
    )
  },
  time: {
    path: (
      <g fill={"currentColor"}>
        <path
          d={
            "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
          }
        />
        <path
          d={
            "M17.134,15.81,12.5,11.561V6.5a1,1,0,0,0-2,0V12a1,1,0,0,0,.324.738l4.959,4.545a1.01,1.01,0,0,0,1.413-.061A1,1,0,0,0,17.134,15.81Z"
          }
        />
      </g>
    )
  },
  "up-down": {
    viewBox: "-1 -1 9 11",
    path: (
      <path
        fill={"currentColor"}
        d={
          "M 3.5 0L 3.98809 -0.569442L 3.5 -0.987808L 3.01191 -0.569442L 3.5 0ZM 3.5 9L 3.01191 9.56944L 3.5 9.98781L 3.98809 9.56944L 3.5 9ZM 0.488094 3.56944L 3.98809 0.569442L 3.01191 -0.569442L -0.488094 2.43056L 0.488094 3.56944ZM 3.01191 0.569442L 6.51191 3.56944L 7.48809 2.43056L 3.98809 -0.569442L 3.01191 0.569442ZM -0.488094 6.56944L 3.01191 9.56944L 3.98809 8.43056L 0.488094 5.43056L -0.488094 6.56944ZM 3.98809 9.56944L 7.48809 6.56944L 6.51191 5.43056L 3.01191 8.43056L 3.98809 9.56944Z"
        }
      />
    )
  },
  "triangle-down": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z"
        }
      />
    )
  },
  "triangle-up": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z"
        }
      />
    )
  },
  "unknown-vehicle": {
    path: (
      <g fill={"currentcolor"}>
        <path
          d={
            "M17.3332 5.91675V5.50008C17.3332 5.27907 17.2454 5.0671 17.0891 4.91082C16.9328 4.75454 16.7209 4.66675 16.4999 4.66675H15.4249L15.0415 1.93341C14.9849 1.53295 14.7846 1.16674 14.478 0.903025C14.1714 0.639313 13.7793 0.4961 13.3749 0.500081H4.60819C4.20377 0.4961 3.8117 0.639313 3.50506 0.903025C3.19842 1.16674 2.99813 1.53295 2.94152 1.93341L2.57486 4.66675H1.49986C1.27884 4.66675 1.06688 4.75454 0.910603 4.91082C0.754322 5.0671 0.666525 5.27907 0.666525 5.50008V5.91675C0.666525 6.02725 0.710424 6.13323 0.788564 6.21137C0.866704 6.28952 0.972685 6.33341 1.08319 6.33341H1.49986C0.960128 6.9454 0.663624 7.7341 0.666525 8.55008V14.6667C0.666525 14.8878 0.754322 15.0997 0.910603 15.256C1.06688 15.4123 1.27884 15.5001 1.49986 15.5001H3.16652C3.38754 15.5001 3.5995 15.4123 3.75578 15.256C3.91206 15.0997 3.99986 14.8878 3.99986 14.6667V13.0001H13.9999V14.6667C13.9999 14.8878 14.0877 15.0997 14.2439 15.256C14.4002 15.4123 14.6122 15.5001 14.8332 15.5001H16.4999C16.7209 15.5001 16.9328 15.4123 17.0891 15.256C17.2454 15.0997 17.3332 14.8878 17.3332 14.6667V8.54175C17.3341 7.72863 17.0377 6.94325 16.4999 6.33341H16.9499C17.0545 6.32502 17.1521 6.27744 17.2232 6.20019C17.2942 6.12294 17.3335 6.02171 17.3332 5.91675ZM16.4999 14.6667H14.8332V12.1667H3.16652V14.6667H1.49986V8.55008C1.50014 8.2199 1.56583 7.89304 1.69313 7.58839C1.82043 7.28373 2.00681 7.00731 2.24153 6.77508L3.27486 5.62508L3.78319 2.05008C3.81149 1.84985 3.91164 1.66674 4.06496 1.53489C4.21828 1.40303 4.41431 1.33142 4.61652 1.33341H13.3915C13.5937 1.33142 13.7898 1.40303 13.9431 1.53489C14.0964 1.66674 14.1966 1.84985 14.2249 2.05008L14.7332 5.62508L15.7749 6.78341C16.2387 7.25112 16.4993 7.88301 16.4999 8.54175V14.6667Z"
          }
        />
        <path
          d={
            "M9.23319 8.16675C9.2059 7.89329 9.25261 7.61751 9.36842 7.36829C9.48424 7.11907 9.66491 6.90555 9.89153 6.75008C11.0082 5.91675 11.2749 5.31675 11.2749 4.55841C11.2749 3.23341 10.4415 2.58341 9.00819 2.58341C8.31286 2.59725 7.64288 2.84702 7.10819 3.29175V4.55008C7.5439 4.11043 8.13123 3.85403 8.74986 3.83341C9.44152 3.83341 9.89986 4.11675 9.89986 4.81675C9.89986 5.34175 9.59153 5.74175 8.90819 6.31675C8.64264 6.53887 8.4393 6.82613 8.31806 7.15041C8.19682 7.47469 8.16184 7.82489 8.21653 8.16675H9.23319ZM9.54986 10.0501C9.54986 9.88526 9.50098 9.72414 9.40942 9.5871C9.31785 9.45006 9.1877 9.34325 9.03543 9.28018C8.88316 9.21711 8.7156 9.2006 8.55395 9.23276C8.3923 9.26491 8.24381 9.34428 8.12727 9.46082C8.01073 9.57737 7.93136 9.72585 7.8992 9.8875C7.86705 10.0492 7.88355 10.2167 7.94663 10.369C8.0097 10.5213 8.11651 10.6514 8.25355 10.743C8.39059 10.8345 8.55171 10.8834 8.71653 10.8834C8.93754 10.8834 9.1495 10.7956 9.30578 10.6393C9.46206 10.4831 9.54986 10.2711 9.54986 10.0501Z"
          }
        />
      </g>
    ),
    viewBox: "0 0 18 16"
  },
  visitor: {
    path: (
      <g fill={"currentcolor"}>
        <path
          d={
            "M5.99984 7.33366C6.65911 7.33366 7.30357 7.13816 7.85174 6.77189C8.3999 6.40562 8.82714 5.88503 9.07944 5.27594C9.33173 4.66685 9.39774 3.99663 9.26912 3.35003C9.14051 2.70342 8.82304 2.10948 8.35686 1.6433C7.89069 1.17713 7.29674 0.85966 6.65014 0.731043C6.00354 0.602425 5.33331 0.668436 4.72423 0.920729C4.11514 1.17302 3.59454 1.60026 3.22827 2.14843C2.862 2.69659 2.6665 3.34106 2.6665 4.00033C2.6665 4.88438 3.01769 5.73223 3.64281 6.35735C4.26794 6.98247 5.11578 7.33366 5.99984 7.33366ZM5.99984 1.50033C6.49429 1.50033 6.97764 1.64695 7.38876 1.92165C7.79989 2.19636 8.12032 2.5868 8.30954 3.04362C8.49876 3.50043 8.54826 4.0031 8.4518 4.48805C8.35534 4.97301 8.11724 5.41846 7.76761 5.7681C7.41797 6.11773 6.97252 6.35583 6.48756 6.45229C6.00261 6.54875 5.49994 6.49925 5.04313 6.31003C4.58631 6.12081 4.19587 5.80038 3.92116 5.38925C3.64646 4.97813 3.49984 4.49478 3.49984 4.00033C3.49984 3.33729 3.76323 2.7014 4.23207 2.23256C4.70091 1.76372 5.3368 1.50033 5.99984 1.50033Z"
          }
        />
        <path
          d={
            "M10.1665 8.16699H1.83317C1.39114 8.16699 0.96722 8.34259 0.654659 8.65515C0.342099 8.96771 0.166504 9.39163 0.166504 9.83366V17.3337H11.8332V9.83366C11.8332 9.39163 11.6576 8.96771 11.345 8.65515C11.0325 8.34259 10.6085 8.16699 10.1665 8.16699ZM10.9998 16.5003H0.999837V9.83366C0.999837 9.61265 1.08763 9.40069 1.24392 9.24441C1.4002 9.08813 1.61216 9.00033 1.83317 9.00033H10.1665C10.3875 9.00033 10.5995 9.08813 10.7558 9.24441C10.912 9.40069 10.9998 9.61265 10.9998 9.83366V16.5003Z"
          }
        />
        <path
          d={
            "M8.61651 10.3837L5.1665 14.0003L3.3915 12.0503C3.3543 12.0098 3.30948 11.9771 3.25961 11.9539C3.20974 11.9307 3.15579 11.9176 3.10085 11.9153C3.04591 11.913 2.99105 11.9215 2.9394 11.9404C2.88775 11.9593 2.84033 11.9881 2.79984 12.0253C2.75935 12.0625 2.72658 12.1074 2.70341 12.1572C2.68024 12.2071 2.66712 12.261 2.6648 12.316C2.66248 12.3709 2.671 12.4258 2.68988 12.4774C2.70876 12.5291 2.73763 12.5765 2.77484 12.617L5.1665 15.242L9.22484 10.9503C9.27137 10.9131 9.30937 10.8663 9.33627 10.8131C9.36317 10.7599 9.37836 10.7016 9.3808 10.6421C9.38324 10.5825 9.37287 10.5232 9.35041 10.468C9.32794 10.4128 9.2939 10.363 9.25057 10.3221C9.20725 10.2812 9.15565 10.25 9.09926 10.2308C9.04286 10.2115 8.98299 10.2045 8.92368 10.2104C8.86438 10.2162 8.80701 10.2347 8.75545 10.2646C8.7039 10.2945 8.65936 10.3351 8.62484 10.3837H8.61651Z"
          }
        />
      </g>
    ),
    viewBox: "0 0 12 18"
  },
  warning: {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        }
      />
    )
  },
  "warning-2": {
    path: (
      <path
        fill={"currentColor"}
        d={
          "M23.119,20,13.772,2.15h0a2,2,0,0,0-3.543,0L.881,20a2,2,0,0,0,1.772,2.928H21.347A2,2,0,0,0,23.119,20ZM11,8.423a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Zm1.05,11.51h-.028a1.528,1.528,0,0,1-1.522-1.47,1.476,1.476,0,0,1,1.448-1.53h.028A1.527,1.527,0,0,1,13.5,18.4,1.475,1.475,0,0,1,12.05,19.933Z"
        }
      />
    )
  },
  police: {
    viewBox: "0 0 30 34",
    path: (
      <path
        fill={"currentColor"}
        d={
          "M21.4061 14.0572L17.4223 13.5611L15.7016 10.1009C15.5657 9.82781 15.2823 9.65449 14.9716 9.65449C14.6608 9.65449 14.3774 9.82781 14.2415 10.1009L12.5208 13.5611L8.537 14.0572C8.22423 14.0961 7.96282 14.3085 7.8666 14.6019C7.77039 14.8952 7.85678 15.2165 8.08815 15.4258L10.9939 18.0543L10.2605 21.8084C10.2019 22.1083 10.3247 22.4145 10.5763 22.5956C10.8279 22.7767 11.1635 22.8007 11.4394 22.6571L14.9717 20.8189L18.5039 22.6571C18.7797 22.8007 19.1154 22.7767 19.367 22.5956C19.6186 22.4145 19.7414 22.1083 19.6828 21.8084L18.9494 18.0543L21.8551 15.4258C22.0865 15.2165 22.1729 14.8952 22.0767 14.6019C21.9805 14.3085 21.7189 14.0961 21.4061 14.0572ZM17.5155 17.1893C17.31 17.3751 17.217 17.6513 17.2695 17.92L17.7694 20.4784L15.3524 19.2205C15.1139 19.0964 14.8279 19.0964 14.5894 19.2205L12.1723 20.4784L12.6721 17.9198C12.7246 17.6511 12.6317 17.3749 12.4262 17.1891L10.4654 15.4158L13.1601 15.0802C13.4318 15.0464 13.6678 14.8809 13.7875 14.6402L14.9709 12.2612L16.1542 14.6402C16.2739 14.8809 16.5098 15.0464 16.7816 15.0802L19.4763 15.4158L17.5155 17.1893ZM27.4616 11.3621C27.4616 9.38413 29.6867 7.53562 29.7082 7.51801C30.041 7.2468 30.097 6.76793 29.8354 6.43032L26.8477 2.57549C26.642 2.30945 26.2877 2.19783 25.9617 2.29635C25.8953 2.31617 19.2736 4.25318 15.5345 0.56758C15.3821 0.417452 15.1747 0.333008 14.9583 0.333008C14.7418 0.333008 14.5344 0.417452 14.382 0.56758C10.6574 4.23859 4.10629 2.3157 4.04135 2.29635C3.71415 2.19645 3.35798 2.30817 3.15144 2.57549L0.164515 6.43064C-0.089588 6.75862 -0.0448267 7.22197 0.267596 7.49771C0.844528 8.0073 2.34286 9.69499 2.34286 11.3621C2.34286 12.0512 1.95992 12.9432 1.51626 13.9761C0.607197 16.0917 -0.522965 18.7249 0.523596 21.9808C2.41607 27.868 9.35159 31.9345 14.7157 33.6279C14.8779 33.6791 15.0525 33.6791 15.2147 33.6279C20.6131 31.9238 27.5866 27.8508 29.4733 21.9808C30.5184 18.7295 29.3155 16.1002 28.3489 13.9873C27.873 12.9481 27.4616 12.0493 27.4616 11.3621ZM27.9244 21.5056C26.5419 25.8069 21.4698 29.9227 14.9652 32.0388C8.50584 29.9363 3.45988 25.8206 2.07242 21.5058C1.20377 18.8035 2.16511 16.565 3.01395 14.5907C3.52513 13.3999 3.96684 12.3714 3.96684 11.363C3.96684 9.39634 2.64399 7.67503 1.88021 6.84507L4.11749 3.9585C5.33142 4.24043 6.57333 4.39147 7.82095 4.40893C10.7033 4.44065 13.1513 3.68237 14.9582 2.20261C16.7293 3.65097 19.1263 4.41004 21.9519 4.40988C22.0132 4.40988 22.0753 4.40988 22.1369 4.40893C23.3983 4.3911 24.654 4.23938 25.8818 3.95644L28.102 6.82207C27.2753 7.65251 25.8383 9.37953 25.8383 11.3621C25.8383 12.3874 26.3151 13.4291 26.867 14.6353C27.766 16.6005 28.7853 18.8275 27.9244 21.5056Z"
        }
      />
    )
  },
  camera: {
    viewBox: "0 0 34 20",
    path: (
      <path
        fill={"currentColor"}
        d={
          "M32.7833 2.3C32.7833 2.3 32.7783 2.3 32.7749 2.3C32.6183 2.3 32.4716 2.34333 32.3466 2.41833L32.3499 2.41667L26.9999 5.65V1.66667C26.9999 0.746667 26.2533 0 25.3333 0H1.99992C1.07992 0 0.333252 0.746667 0.333252 1.66667V18.3333C0.333252 19.2533 1.07992 20 1.99992 20H25.3333C26.2533 20 26.9999 19.2533 26.9999 18.3333V14.3333L32.3499 17.5667C32.4716 17.64 32.6183 17.6833 32.7749 17.6833C32.7783 17.6833 32.7799 17.6833 32.7833 17.6833C33.2433 17.6833 33.6166 17.31 33.6166 16.85V3.13333C33.6166 2.67333 33.2433 2.3 32.7833 2.3ZM25.3333 18.3333H1.99992V1.66667H25.3333V18.3333ZM31.9999 15.3833L26.9999 12.4V7.6L31.9999 4.61667V15.3833ZM21.9999 13.3333C21.0799 13.3333 20.3333 14.08 20.3333 15C20.3333 15.92 21.0799 16.6667 21.9999 16.6667C22.9199 16.6667 23.6666 15.92 23.6666 15C23.6666 14.08 22.9199 13.3333 21.9999 13.3333Z"
        }
      />
    )
  },
  plane: {
    viewBox: "0 0 14 18",
    path: (
      <path
        d={
          "M13.3683 1L1.43848 8.74182L6.44146 10.2904L7.59578 17L13.3683 1ZM2.22614 8.58034L12.7909 1.77407L7.71629 15.9438L6.63384 10.0323L2.22614 8.58034Z"
        }
        fill={"currentColor"}
        stroke={"currentColor"}
        strokeWidth={"0.5"}
      />
    )
  }
} as const;
